export const complyAdvantageEvents = ['sanction', 'warning', 'adverseMedia']

export const sortVettingEvents = (a: string, b: string) => {
  const sortOrder = [...complyAdvantageEvents, 'hateSpeech', 'controversial', 'commercial']

  return sortOrder.indexOf(a) - sortOrder.indexOf(b)
}
